import React from 'react';

import { VideoPlayer } from '@ael/shared-components-library';
import { MediaLibrarySingleAssetProvider } from '../../MediaLibraryAssetProvider/MediaLibrarySingleAssetProvider';
import { WidgetType } from '@ael/core-api';

type MediaLibraryVideoWidgetData = {
  src: string;
};

type MediaLibraryVideoProps = {
  assetId: string;
  widgetId: string;
  autoplay: boolean;
  seekBarLocked: boolean;
  hideControls: boolean;
  loop: boolean;
  mute: boolean;
  onVideoEnded?: () => void;
};

export const MediaLibraryVideo: React.FC<MediaLibraryVideoProps> = ({
  assetId,
  widgetId,
  autoplay,
  seekBarLocked,
  hideControls,
  loop,
  mute,
  onVideoEnded,
}) => (
  <MediaLibrarySingleAssetProvider<MediaLibraryVideoWidgetData>
    assetId={assetId}
    widgetId={widgetId}
    widgetType={WidgetType.video}
  >
    {(data) => {
      if (data && data.src) {
        return (
          <VideoPlayer
            src={data.src}
            autoplay={autoplay}
            seekBarLocked={seekBarLocked}
            hideControls={hideControls}
            loop={loop}
            mute={mute}
            onEnded={onVideoEnded}
          />
        );
      }
      return null;
    }}
  </MediaLibrarySingleAssetProvider>
);
